var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 17.801,
    viewBox: "0 0 12 17.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5489",
    "data-name": "Rectangle 5489",
    width: 12,
    height: 17.801,
    fill: "#7dab3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9606",
    "data-name": "Group 9606",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29918",
    "data-name": "Path 29918",
    d: "M3.133,0c.058.435.111.847.168,1.258a2.009,2.009,0,0,0,.053.252.954.954,0,0,0,1.082.828l3.018,0c.833,0,1.136-.268,1.25-1.1C8.76.833,8.821.429,8.881.015,8.948.01,9,0,9.05,0c.615,0,1.231,0,1.846,0A1.036,1.036,0,0,1,12,1.109Q12,8.9,12,16.7a1.033,1.033,0,0,1-1.088,1.1q-4.9,0-9.808,0A1.083,1.083,0,0,1,0,16.686Q.02,8.9,0,1.118A1.084,1.084,0,0,1,1.121,0c.661.011,1.322,0,2.012,0M2.441,11.467c-.343.113-.37.151-.37.512q0,.338,0,.675c0,.394.08.474.478.474H9.358c.079,0,.159,0,.238,0a.317.317,0,0,0,.339-.353c0-.238-.008-.477,0-.715.014-.294,0-.56-.373-.578v-3.5c.169,0,.326,0,.484,0a.325.325,0,0,0,.348-.209.329.329,0,0,0-.126-.386Q8.256,5.654,6.243,3.915a.317.317,0,0,0-.479,0Q3.742,5.66,1.721,7.4a.324.324,0,0,0,.217.582c.164,0,.328,0,.5,0ZM5.993,16.33c.337,0,.675,0,1.012,0,.223,0,.355-.121.358-.311S7.231,15.7,7,15.7q-.993,0-1.985,0c-.235,0-.371.123-.368.321s.138.312.377.313c.324,0,.648,0,.973,0",
    transform: "translate(0 0)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29919",
    "data-name": "Path 29919",
    d: "M70.764.245h4.5c-.079.475-.144.938-.237,1.4-.05.246-.143.294-.395.294-1.077,0-2.155,0-3.232,0-.2,0-.343-.068-.381-.264-.091-.47-.167-.944-.251-1.429",
    transform: "translate(-67.01 -0.232)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29920",
    "data-name": "Path 29920",
    d: "M55.581,85.712,58.808,88.5H52.354l3.227-2.789",
    transform: "translate(-49.577 -81.165)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5483",
    "data-name": "Rectangle 5483",
    width: 0.946,
    height: 3.485,
    transform: "translate(4.181 7.993)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5484",
    "data-name": "Rectangle 5484",
    width: 0.954,
    height: 3.481,
    transform: "translate(6.876 7.997)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5485",
    "data-name": "Rectangle 5485",
    width: 6.568,
    height: 0.339,
    transform: "translate(2.723 12.144)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5486",
    "data-name": "Rectangle 5486",
    width: 0.419,
    height: 3.483,
    transform: "translate(5.794 8.002)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5487",
    "data-name": "Rectangle 5487",
    width: 0.421,
    height: 3.484,
    transform: "translate(3.101 7.995)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5488",
    "data-name": "Rectangle 5488",
    width: 0.424,
    height: 3.484,
    transform: "translate(8.483 7.997)",
    fill: "#7dab3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.dc321bce5bb9b9293cf0c0962c2bfe34.svg";
export { ForwardRef as ReactComponent };